import React, { useState } from 'react';
import { Menu, X, Scale } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const phoneNumber = '095 222 4610';
  const links = [{
    name: 'Послуги',
    href: '#services'
  }, {
    name: 'Процес',
    href: '#process'
  }, {
    name: 'FAQ',
    href: '#faq'
  }, {
    name: 'Контакти',
    href: '#contact'
  }];
  return <header className="fixed top-0 left-0 right-0 z-40 bg-white/80 backdrop-blur-md border-b border-neutral-100" data-id="element-69">
      <div className="container mx-auto px-6 h-20 flex items-center justify-between" data-id="element-70">
        <a href="#" className="flex items-center gap-2 text-neutral-900" data-id="element-71">
          <Scale className="w-6 h-6" data-id="element-72" />
          <span className="font-semibold text-lg tracking-tight" data-id="element-73">Адвокат</span>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-74">
          {links.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-neutral-600 hover:text-neutral-900 transition-colors" data-id="element-75">
              {link.name}
            </a>)}
        </nav>

        <div className="hidden md:flex items-center gap-4" data-id="element-76">
          <a href="tel:0952224610" className="text-sm font-semibold text-neutral-900 hover:text-neutral-600 transition-colors" data-id="element-77">
            {phoneNumber}
          </a>
        </div>

        {/* Mobile Toggle */}
        <button className="md:hidden p-2 text-neutral-900" onClick={() => setIsOpen(!isOpen)} data-id="element-78">
          {isOpen ? <X className="w-6 h-6" data-id="element-79" /> : <Menu className="w-6 h-6" data-id="element-80" />}
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-81">
        {isOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-white border-b border-neutral-100 overflow-hidden" data-id="element-82">
            <div className="px-6 py-4 flex flex-col gap-4" data-id="element-83">
              {links.map(link => <a key={link.name} href={link.href} onClick={() => setIsOpen(false)} className="text-base font-medium text-neutral-600 hover:text-neutral-900" data-id="element-84">
                  {link.name}
                </a>)}
              <a href="tel:0952224610" className="text-base font-semibold text-neutral-900 mt-2 pt-4 border-t border-neutral-100" data-id="element-85">
                {phoneNumber}
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}